import { Link } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { Icon } from '#app/components/ui/icon.tsx'
import CATEGORIES from '#app/data/competency-categories.json'
import { getAbilitiesByCategory } from '#app/modules/personnel-system/competency/abilities.ts'
import { MarkdownPreview } from '../_components/markdown'

export default function Page() {
	return (
		<main className="px-[24px] py-[32px]">
			<section>
				<h1 className="text-2xl">メンバーに求める能力要素</h1>
			</section>
			<section className="mt-[32px]">
				<menu className="rounded-md border px-[16px] py-[8px]">
					{CATEGORIES.map((category, categoryIndex) => {
						const abilities = getAbilitiesByCategory(category.category)
						return (
							<MenuLine
								key={categoryIndex}
								title={category.label}
								abilities={abilities}
								noBorder={CATEGORIES.length === categoryIndex + 1}
							/>
						)
					})}
				</menu>
			</section>
			<section>
				{CATEGORIES.map((category, categoryIndex) => {
					const abilities = getAbilitiesByCategory(category.category)
					return (
						<section key={categoryIndex} className="mt-[32px]">
							<h2 className="mt-[8px] border-b text-xl">{category.label}</h2>
							{abilities.map((ability, abilityIndex) => {
								return (
									<AbilityDescription
										ability={ability}
										key={abilityIndex}
										noBorder={abilities.length === abilityIndex + 1}
									/>
								)
							})}
						</section>
					)
				})}
			</section>
			<ScrollToTopButton />
		</main>
	)
}

const MenuLine = ({
	title,
	noBorder = false,
	abilities,
}: {
	title: string
	noBorder?: boolean
	abilities: { key: string; name: string; description: string }[]
}) => (
	<li
		className={`${noBorder ? '' : 'border-b border-dashed'}  text-md py-[12px]`}
	>
		<details className="group">
			<summary className="flex content-center items-center  justify-between hover:text-primary">
				{title}
				<span className="transition-transform group-open:hidden">
					<Icon name="plus" />
				</span>
				<span className="hidden group-open:inline">
					<Icon name="minus" />
				</span>
			</summary>
			<ul className="mt-[12px]">
				{abilities.map((ability, abilityIndex) => {
					return (
						<li
							key={abilityIndex}
							className={`py-[8px] text-sm hover:text-primary ${abilityIndex === 0 ? 'border-t border-dashed' : ''}`}
						>
							<Link to={`#${ability.key}`}>{ability.name}</Link>
						</li>
					)
				})}
			</ul>
		</details>
	</li>
)

const AbilityDescription = ({
	ability,
	noBorder = false,
}: {
	ability: { key: string; name: string; description: string }
	noBorder?: boolean
}) => (
	<article
		id={ability.key}
		className={`${noBorder ? '' : 'border-b'} py-[16px]`}
	>
		<h3 className="font-semibold">{ability.name}</h3>
		<MarkdownPreview value={ability.description} className="text-sm" />
	</article>
)

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false)

	// スクロール時の処理
	useEffect(() => {
		const toggleVisibility = () => {
			setIsVisible(window.scrollY > 300)
		}

		window.addEventListener('scroll', toggleVisibility)
		return () => window.removeEventListener('scroll', toggleVisibility)
	}, [])

	// スクロールしてトップへ
	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}

	return (
		<div>
			{isVisible && (
				<button
					onClick={scrollToTop}
					className="fixed bottom-5 right-5 rounded-full shadow-lg transition-opacity duration-300"
				>
					<Icon name="chevron-up-circle" size="xxxl" />
				</button>
			)}
		</div>
	)
}
